import { Component, HostBinding, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ENVIRONMENT_WEBSITE_TOKEN } from '@campus/environment';
import { CampaignInterface, RegistrationCredentials } from '@campus/public-portal';
import '@diekeure/dcr-components/dcr-animated-kai.js';
import { from, Observable } from 'rxjs';
import { catchError, filter, map, shareReplay, switchMap } from 'rxjs/operators';
import { RegisterPageContainerViewModel } from './register-page-container.viewmodel';


@Component({
  standalone: false,
  selector: 'polpo-register-page-container',
  templateUrl: './register-page-container.component.html',
  providers: [RegisterPageContainerViewModel],
})
export class RegisterPageContainerComponent implements OnInit {
  @HostBinding('style.padding-top') paddingTop = '132px';
  @HostBinding('style.display') display = 'block';

  @HostBinding('class') classList = 'block p-m';

  private vm = inject(RegisterPageContainerViewModel);
  private environmentWebsite = inject(ENVIRONMENT_WEBSITE_TOKEN);
  private route = inject(ActivatedRoute);

  public registrationError$ = this.vm.registrationError$;
  public campaign$: Observable<CampaignInterface>;
  public isMaintenanceMode$: Observable<boolean>;
  public statusPageUrl: string;

  ngOnInit(): void {
    this.isMaintenanceMode$ = this.vm.isMaintenanceMode$;
    this.statusPageUrl = this.environmentWebsite.statusPageUrl;

    this.campaign$ = this.route.queryParams.pipe(
      filter((params) => params.campaign),
      map((params) => params.campaign),
      switchMap((campaignKey) =>
        this.vm.getCampaign(campaignKey).pipe(catchError(() => from([{} as CampaignInterface])))
      ),

      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  public register(data: RegistrationCredentials) {
    this.vm.register(data);
  }
}
